/**
 * @generated SignedSource<<7ce6cc193cc37b4484da707ada8e906b>>
 * @relayHash 2eb5932fe57eda221f60bf95729cc781
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d26dc563aec2070c8c92491642682e66884032b661b2c5862a9e3c2f83bcc352

import type { ConcreteRequest } from 'relay-runtime';
export type PageTreeMacroSearchByTitleQuery$variables = {
  cql: string;
};
export type PageTreeMacroSearchByTitleQuery$data = {
  readonly confluence_search: {
    readonly nodes: ReadonlyArray<{
      readonly content: {
        readonly id: string | null;
      } | null;
    } | null> | null;
  } | null;
};
export type PageTreeMacroSearchByTitleQuery = {
  response: PageTreeMacroSearchByTitleQuery$data;
  variables: PageTreeMacroSearchByTitleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cql"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cql",
        "variableName": "cql"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      }
    ],
    "concreteType": "ConfluenceSearchConnection",
    "kind": "LinkedField",
    "name": "confluence_search",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceSearchResponse",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PageTreeMacroSearchByTitleQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PageTreeMacroSearchByTitleQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2eb5932fe57eda221f60bf95729cc781",
    "id": "d26dc563aec2070c8c92491642682e66884032b661b2c5862a9e3c2f83bcc352",
    "metadata": {},
    "name": "PageTreeMacroSearchByTitleQuery",
    "operationKind": "query",
    "text": "query PageTreeMacroSearchByTitleQuery($cql:String!){confluence_search(cql:$cql,first:1){nodes{content{id}}}}"
  }
};
})();

(node as any).hash = "42441e185ca1b3e501257c64db0a4892";

export default node;
